import { PaleoMapOutcropManager } from '~/components/upload/paleomap/paleomap-outcrop-manager';
import { UpdatePaleoMapForm } from '~/components/upload/paleomap/update-paleomap-form';
import { useUpdatePaleoMapOutletContext } from '~/routes/upload/paleomap/$paleoMapId';

export default function UpdatePaleomapDetailsRoute() {
  const { paleoMap: paleomap, refetchQueries } =
    useUpdatePaleoMapOutletContext();

  return (
    <div className="grid lg:grid-cols-2 gap-4">
      <div>
        <UpdatePaleoMapForm paleoMap={paleomap} />
      </div>

      <div>
        <PaleoMapOutcropManager
          paleoMap={paleomap}
          refetchQueries={refetchQueries}
        />
      </div>
    </div>
  );
}
